import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { FormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';
import { SuperAdminService } from '../../services/super-admin.service';
import { MaterialPageGrid, MaterialListQuery } from '../../utils/material-page-grid';
import { UsersService } from '../../services/users.service';

export interface PortalUser {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  nid: string;
  passport: string;
  phoneNumber: string;
  active: boolean;
  role: string;
  createdAt: string;
  lastLoginAt: string;
  avatarUrl?: string;
}

@Component({
  selector: 'app-portal-users',
  templateUrl: './portal-users.component.html',
  styleUrls: ['./portal-users.component.scss'],
})
export class PortalUsersComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  displayedColumns: string[] = ['avatarUrl', 'name', 'email', 'nid', 'phoneNumber', 'role', 'active', 'lastLoginAt', 'actions'];

  portalUsersPageGrid: MaterialPageGrid;
  gridInProgress = false;
  pageSizes = [10, 15, 20, 25, 30, 50, 100];

  private destroy$ = new Subject<void>();

  constructor(private superAdminService: SuperAdminService, private fb: FormBuilder, private userService: UsersService) {}

  async ngOnInit(): Promise<void> {
    await this.initGrid();
  }

  ngAfterViewInit(): void {
    // Attach sort after view is initialized
    // Paginator is handled via template event binding (page)
    setTimeout(() => {
      if (this.portalUsersPageGrid && this.sort) {
        this.portalUsersPageGrid.attachSort(this.sort);
      }
    }, 0);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  async initGrid(): Promise<void> {
    this.portalUsersPageGrid = new MaterialPageGrid(this.fb, 15)
      .setTableColumns(this.displayedColumns)
      .setSource(async (listQuery: MaterialListQuery) => {
        try {
          this.gridInProgress = true;

          // Transform the listQuery to match the API expected format
          const apiQuery = {
            filterValues: {
              searchUsers: listQuery.filterValues?.searchTerm || '',
              role: listQuery.filterValues?.roleFilter === 'ALL' ? '' : listQuery.filterValues?.roleFilter || '',
            },
            page: listQuery.pageIndex,
            size: listQuery.pageSize,
            sortField: listQuery.sortField,
          };

          // Fetch users and count in parallel
          const [usersResponse, countResponse] = await Promise.all([
            this.userService.filteredUserList(apiQuery),
            this.userService.filteredUserListCount(apiQuery),
          ]);

          // Transform the API response to match PortalUser interface
          //   const users = this.transformUsersData(usersResponse);
          const total = countResponse?.count || countResponse?.total || 0;
          console.log(usersResponse);
          //   console.log(users);
          this.gridInProgress = false;
          return { data: usersResponse, total: total };
        } catch (error) {
          console.error('Error loading portal users:', error);
          this.gridInProgress = false;
          return { data: [], total: 0 };
        }
      })
      .setFilters({
        searchTerm: '',
        statusFilter: 'ALL',
        roleFilter: 'ALL',
      });
  }

  clearFilters(): void {
    if (this.portalUsersPageGrid) {
      this.portalUsersPageGrid.filtersForm.patchValue({
        searchTerm: '',
        statusFilter: 'ALL',
        roleFilter: 'ALL',
      });
    }
  }

  onToggleUserStatus(user: PortalUser): void {
    // TODO: Implement toggle user status functionality
    console.log('Toggle user status:', user, 'to');
  }

  refreshUsers(): void {
    if (this.portalUsersPageGrid) {
      this.portalUsersPageGrid.refreshData();
    }
  }
}
